import jQuery from "jquery";
/*!
 * fullpage.js Continuos Horizontal Scrolling Extension 0.0.4
 * https://github.com/alvarotrigo/fullPage.js
 *
 * This code has been bought from www.alvarotrigo.com/fullPage/extensions/ and it is not free to use or distrubute.
 * Copyright (C) 2016 alvarotrigo.com - A project by Alvaro Trigo
 */
! function(n) {
  window.fp_continuousHorizontalExtension = function() {
    const e = this;
    const o = n.fn.fullpage.getFullpageData();
    const t = o.options;
    const i = o.internals;
    const r = "fullpage-wrapper";
    const l = "." + r;
    const s = "active";
    const a = "." + s;
    const d = "fp-section";
    const f = "." + d;
    const u = f + a;
    const p = "fp-slide";
    const c = "." + p;
    const m = "fp-slidesContainer";
    const x = "." + m;
    e.wrapAroundElements = null, e.apply = function(o) {
      const i = o.destiny;
      const r = o.direction;
      const a = o.prevSlide;
      e.wrapAroundElements = null, t.continuousHorizontal && "undefined" != typeof r && r != o.xMovement && ("right" === r ? a.after(a.prevAll(c).get().reverse()) : a.before(a.nextAll(c)), e.silentHorizontalScroll(a.position().left), e.wrapAroundElements = a, o.destinyPos = i.position(), o.slideIndex = i.index(), o.prevSlideIndex = a.index(), n(l).trigger("onContinuosHorizontal", [o])), i.addClass(s).siblings().removeClass(s);
    }, e.fixSectionOrder = function(n, o, t) {
      e.wrapAroundElements && e.wrapAroundElements.length && ("left" == t ? n.find(c + ":first").before(e.wrapAroundElements) : n.find(c + ":last").after(e.wrapAroundElements), e.silentHorizontalScroll(o.position().left));
    }, e.afterSlideLoads = function(n) {
      e.fixSectionOrder(n.slides, n.destiny, n.direction), n.slideIndex = n.destiny.index();
    }, e.silentHorizontalScroll = function(e) {
      const o = n(u).find(x);
      if (t.css3) {
        const r = "translate3d(-" + e + "px, 0px, 0px)";
        i.removeAnimation(o), o.css(i.getTransforms(r));
      } else o.parent().scrollLeft(e);
    }, e.c = i.c;
    const v = e["common".charAt(0)];
    return "complete" === document.readyState && v("continuousHorizontal"), n(window).on("load", function() {
      v("continuousHorizontal");
    }), e;
  };
}(jQuery);
